import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'whatwg-fetch';
import Pikaday from 'pikaday';
require('intersection-observer');
import 'element-closest-polyfill';


// tidy up trading names
const displayNamesListBtn = document.getElementById('display-names-list-btn');
const displayNamesList = document.getElementsByClassName('display-names-list')[0];
if(displayNamesListBtn) {
    displayNamesListBtn.addEventListener('click', () => {
        displayNamesListBtn.innerText = displayNamesList.classList.contains('active') ? 'show more' : 'show less';
        displayNamesList.classList.toggle('active');
    });
}

// only load hcaptcha when the form has an input that focus
function reCaptchaOnFocus() {
    var head = document.getElementsByTagName('head')[0]
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://hcaptcha.com/1/api.js'
    head.appendChild(script);

    bookAnAppointmentModal.querySelector('#bookAppointmentDate').addEventListener('focus', reCaptchaOnFocus, false);
    bookAnAppointmentModal.querySelector('#bookAppointmentName').addEventListener('focus', reCaptchaOnFocus, false);
    bookAnAppointmentModal.querySelector('#bookAppointmentEmail').addEventListener('focus', reCaptchaOnFocus, false);
    bookAnAppointmentModal.querySelector('#bookAppointmentNumber').addEventListener('focus', reCaptchaOnFocus, false);
    bookAnAppointmentModal.querySelector('#bookAppointmentMessage').addEventListener('focus', reCaptchaOnFocus, false);
}

function validateCaptcha(e) {
    e.preventDefault();
    const errorMessage = this.querySelector('.rs-modal__form-error');
    const hCaptchaToken = this.querySelector('[name="h-captcha-response"]');

    if (hCaptchaToken && hCaptchaToken.value.length > 2) {
        errorMessage.classList.remove('rs-modal__form-error--show');
        this.submit();
    }
    else
        errorMessage.classList.add('rs-modal__form-error--show');
};

function animateFeedbackThumb(element, delay) {
    setTimeout(() => {
        const feedbackText = element.parentElement.parentElement.querySelector('.profile-review__helpful-text');
        feedbackText.innerHTML = 'Thank you for your feedback!';
        feedbackText.classList.add('profile-review__helpful-text--green');
    }, delay);
};

async function sendFeedback(e) {
    const reviewId = e.target.closest('.profile-review').dataset.reviewId;
    const csrf = document.querySelector('input[name="_csrf"]').value;
    let formData = new FormData();
    formData.append("_csrf",csrf);

    await fetch(`/service/v1/review/${reviewId}/mark`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams(formData)
    });

    const feedbackContainer = e.target.closest('.profile-review__helpful');
    const feedbackBtn = feedbackContainer.querySelector('.profile-review__helpful-btn');
    const feedbackIcon = feedbackBtn.querySelector('.icon-thumbs-o-up');

    feedbackIcon.classList.add('icon-thumbs-o-up--green');
    feedbackBtn.classList.add('profile-review__helpful-btn--grow');
            
    animateFeedbackThumb(e.target, 300);
};

document.querySelectorAll('.profile-review__helpful-btn').forEach(btn => {
    btn.addEventListener('click', sendFeedback, { once: true });
});

// Helper function - get absolute height of element:
function getAbsoluteHeight(selector) {
    const element = document.querySelector(selector);
    const styles = window.getComputedStyle(element);
    const margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
    return Math.ceil(element.offsetHeight + margin);
};

// CTA Advice / Appointment Modal:
const bookAnAppointmentBtn = document.querySelector('.profile-sidebar-cta__cta-btn');
const bookAnAppointmentBtnSticky = document.querySelector('.profile-reviews__cta-group .profile-top__cta-btn--book-an-appointment');

const bookAnAppointmentModal = document.querySelector('.rs-modal--book-an-appointment');
const bookAnAppointmentModalOverlay = bookAnAppointmentModal.querySelector('.rs-modal__overlay');
const bookAnAppointmentModalCloseBtn = bookAnAppointmentModal.querySelector('.rs-modal__close-link');
const bookAnAppointmentModalCloseIcon = bookAnAppointmentModal.querySelector('.rs-modal__close-icon');

const bookAnAppointmentModalWrongFirmTypeError = bookAnAppointmentModal.querySelector('.rs-modal__wrong-firm-type');
const bookAnAppointmentModalRequestBtn = bookAnAppointmentModal.querySelector('#modal-request-appointment-btn');

bookAnAppointmentModal.querySelector('#bookAppointmentDate').addEventListener('focus', reCaptchaOnFocus, false);
bookAnAppointmentModal.querySelector('#bookAppointmentName').addEventListener('focus', reCaptchaOnFocus, false);
bookAnAppointmentModal.querySelector('#bookAppointmentEmail').addEventListener('focus', reCaptchaOnFocus, false);
bookAnAppointmentModal.querySelector('#bookAppointmentNumber').addEventListener('focus', reCaptchaOnFocus, false);
bookAnAppointmentModal.querySelector('#bookAppointmentMessage').addEventListener('focus', reCaptchaOnFocus, false);

const openBookAnAppointmentModal = () => {
    bookAnAppointmentModal.classList.add('rs-modal--open');
    document.body.classList.add('no-scroll');
};

const closeBookAnAppointmentModal = (e) => {
    if (
        e.target !== bookAnAppointmentModalOverlay && 
        e.target !== bookAnAppointmentModalCloseBtn && 
        e.target !== bookAnAppointmentModalCloseIcon && 
        e.target.classList[0] !== 'rs-modal__close-icon-bar'
    ) return;
    
    bookAnAppointmentModal.classList.remove('rs-modal--open');
    document.body.classList.remove('no-scroll');
};

const showWrongFirmTypeError = (e) => {
    bookAnAppointmentModalRequestBtn.style.display = "none";
    bookAnAppointmentModalWrongFirmTypeError.style.display = "inline";
}

bookAnAppointmentBtn.addEventListener('click', openBookAnAppointmentModal);
bookAnAppointmentBtnSticky.addEventListener('click', openBookAnAppointmentModal);
bookAnAppointmentModalCloseBtn.addEventListener('click', closeBookAnAppointmentModal);
bookAnAppointmentModal.addEventListener('click', closeBookAnAppointmentModal);

bookAnAppointmentModalRequestBtn.addEventListener('click', showWrongFirmTypeError);

// Book an appointment datepicker
const bookAnAppointmentDateInput = bookAnAppointmentModal.querySelector('.rs-modal__input-date--book-an-appointment');
const bookAnAppointmentCalendarIcon = document.querySelector('.rs-modal__input-container .icon-calendar');
const branchAppointmentDelay = delay;
const bookAnAppointmentTimepicker = document.querySelector('.rs-modal__form--book-an-appointment .rs-modal__timepicker');
const bookAnAppointmentTimepickerItems = bookAnAppointmentTimepicker.querySelectorAll('.rs-modal__timepicker-item');

bookAnAppointmentCalendarIcon.addEventListener('click', () => bookAnAppointmentDateInput.click());

const updateTimepickerFields = (selectedDate) => {

    let now = new Date();
    now.setHours(now.getHours() + branchAppointmentDelay);
    const isToday = selectedDate.toDateString() == now.toDateString();

    bookAnAppointmentTimepickerItems.forEach((item, index) => {

        const itemRadio = item.querySelector('.rs-modal__timepicker-radio');
        item.classList.remove('rs-modal__timepicker-item--disabled');
        itemRadio.removeAttribute('checked');
        itemRadio.checked = false;
        
        if (isToday)
        {
            const value = itemRadio.value;
            const temp = new Date();
            temp.setHours(value.split(':')[0],0,0,0);
            if (temp < now)
            {
                const disabled = document.createAttribute('disabled');
                item.classList.add('rs-modal__timepicker-item--disabled');
                itemRadio.setAttributeNode(disabled);
            }
        } 
        else
        {
            itemRadio.removeAttribute('disabled');
        }

        if (!isToday && index === 0)
        {
            const checked = document.createAttribute('checked')
            itemRadio.setAttributeNode(checked);
            itemRadio.checked = true;
        }
    });
};

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
tomorrow.setHours(9);

const isPastFourPm = today.getHours() >= 16;
const isFriday = today.getDay() === 5;
const isSaturday = today.getDay() === 6;
const isSunday = today.getDay() === 0;
const isWeekday = !isFriday && !isSaturday && !isSunday;

let minDate;

if (isWeekday && isPastFourPm || isSunday)
{
    minDate = tomorrow;
} 
else if (isFriday && isPastFourPm)
{
    tomorrow.setDate(tomorrow.getDate() + 2);
    minDate = tomorrow;
}
else if (isSaturday)
{
    tomorrow.setDate(tomorrow.getDate() + 1);
    minDate = today;
} 
else
{
    minDate = today;
}

function updateCalendarWidth() {
    const dateInputWidth = bookAnAppointmentDateInput.getBoundingClientRect().width;
    const pikadayCalendar = document.querySelector('.pika-lendar');
    pikadayCalendar.style.width = dateInputWidth + 'px';
};

const datepicker = new Pikaday(
    { 
        field: bookAnAppointmentDateInput, 
        minDate: minDate,
        defaultDate: minDate,
        setDefaultDate: true,
        disableWeekends: true,
        format: 'DD MM YYYY',
        toString(date, format) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        onSelect(date) {
            updateTimepickerFields(date);            
        },
        onOpen() {
            updateCalendarWidth();
        },
        onDraw() {
            updateCalendarWidth();
        }
    }
);

updateTimepickerFields(new Date());


// Map Section
const mapBtn = document.querySelector('.profile-top__cta-btn--map');
const mapChevron = mapBtn.querySelector('.icon-chevron-down');
const mapDropdown = document.querySelector('.profile-top__map-dropdown');

let isMapDropdownOpen = false;

mapBtn.addEventListener('mouseover', () => {
    mapDropdown.style.borderColor = '#00cb61';
});

mapBtn.addEventListener('mouseout', () => {
    mapDropdown.style.borderColor = '#00af54';
});

mapBtn.addEventListener('click', () => {
    const mapImageHeight = getAbsoluteHeight('.profile-top__map-dropdown img');

    if (!isMapDropdownOpen)
    {
        mapDropdown.style.height = mapImageHeight + 'px';
    }
    else if (isMapDropdownOpen)
    {
        mapDropdown.style.height = '0px';
    }

    mapChevron.classList.toggle('icon-chevron-down--open');
    isMapDropdownOpen = !isMapDropdownOpen;
});

window.addEventListener('resize', () => {
    if (isMapDropdownOpen && window.innerWidth >= 768)
    {
        mapDropdown.classList.remove('profile-top__map-dropdown--open');
        mapChevron.classList.remove('icon-chevron-down--open');
        isMapDropdownOpen = false;
    }
});

// Rankings

const rankingsGroup = document.querySelector('.profile-rankings__group');
const rankingsShowMoreBtn = document.querySelector('.profile-rankings__show-more-btn');
let rankingsGroupIsOpen = false;

if (rankingsShowMoreBtn)
{
    rankingsShowMoreBtn.addEventListener('click', () => {
        rankingsGroup.classList.toggle('profile-rankings__group--open');
        rankingsGroupIsOpen ? rankingsShowMoreBtn.innerHTML = 'Show more' : rankingsShowMoreBtn.innerHTML = 'Show less';
        rankingsGroupIsOpen = !rankingsGroupIsOpen;
    });
}

// Value for money charts

const valueForMoneyChart = document.querySelector('.profile-comparison__chart--value');
const valueForMoneyInfoSection = document.querySelector('.profile-comparison__info--value');
const valueForMoneyReadMoreBtn = document.querySelector('.profile-comparison__read-more--value');

valueForMoneyReadMoreBtn?.addEventListener('click', () => {
    valueForMoneyChart.classList.toggle('profile-comparison__chart--open')
    valueForMoneyInfoSection.classList.toggle('profile-comparison__info--open');
});

const recommendChart = document.querySelector('.profile-comparison__chart--recommend');
const recommendInfoSection = document.querySelector('.profile-comparison__info--recommend');
const recommendReadMoreBtn = document.querySelector('.profile-comparison__read-more--recommend');

recommendReadMoreBtn?.addEventListener('click', () => {
    recommendChart.classList.toggle('profile-comparison__chart--open')
    recommendInfoSection.classList.toggle('profile-comparison__info--open');
});

const satisfactionChart = document.querySelector('.profile-comparison__chart--satisfaction');
const satisfactionInfoSection = document.querySelector('.profile-comparison__info--satisfaction');
const satisfactionReadMoreBtn = document.querySelector('.profile-comparison__read-more--satisfaction');

satisfactionReadMoreBtn?.addEventListener('click', () => {
    satisfactionChart.classList.toggle('profile-comparison__chart--open')
    satisfactionInfoSection.classList.toggle('profile-comparison__info--open');
});

// Reviews Summary and Value for money bar animations
// Intersection Observer API


const valueForMoneyComparisonCharts = document.querySelectorAll('.profile-comparison__chart');
const observerConfig = { rootMargin: '0px' };

const firmComparisonBarsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting)
        {   
            entry.target.addEventListener('transitionend', function showText() {
                const barText = entry.target.querySelector('.profile-comparison__bar-text');
                barText.classList.add('profile-comparison__bar-text--visible');
                entry.target.removeEventListener('transitionend', showText);
            });
            entry.target.classList.remove('w-0');
            firmComparisonBarsObserver.unobserve(entry.target);
        }
    });
}, observerConfig);

let firmComparisonBars = []

valueForMoneyComparisonCharts.forEach(chart => {
    const comparisonBar = chart.querySelector('.profile-comparison__bar');
    firmComparisonBars.push(comparisonBar);
});

firmComparisonBars.forEach(bar => {
    firmComparisonBarsObserver.observe(bar);
});

const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;

            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);

            if (progress < 1) window.requestAnimationFrame(step);
    };

    window.requestAnimationFrame(step);
};

const reviewSourcesAtAGlanceContainer = document.querySelector('.profile-review-sources__at-a-glance');
const reviewSourcesSummaryContainer = document.querySelector('.profile-review-sources__summary');
const reviewSourcesOverallExperienceContainer = document.querySelector('.profile-review-sources__overall-experience');

const reviewSourcesAtAGlanceObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting)
        {   
            const reviewsAmountContainer = document.querySelector('.profile-review-sources__reviews-amount');
            const reviewsAmount = reviewsAmountContainer.getAttribute('data-reviews-amount');
            const ratingStarsContainer = entry.target.querySelector('.profile-review-sources__rating-stars');
            const ratingStars = entry.target.querySelectorAll('.icon-star');
            const ratingNumber = ratingStarsContainer ? Math.round(parseFloat(ratingStarsContainer.getAttribute('data-stars'))) : 0;

            animateValue(reviewsAmountContainer, 0, reviewsAmount, 2000);

            ratingStars.forEach((star, index) => {
                if (index < ratingNumber)
                {
                    star.addEventListener('animationend', function fillStar() {
                        star.classList.add('icon-star--yellow-fill');
                        star.removeEventListener('animationend', fillStar);
                    });
                    star.classList.add('icon-star--yellow', `icon-star--yellow-${index + 1}`);
                }
                return;
            });

            reviewSourcesAtAGlanceObserver.unobserve(entry.target);
        }
    });
}, observerConfig);

reviewSourcesAtAGlanceObserver.observe(reviewSourcesAtAGlanceContainer);

const reviewSummaryBarsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting)
        {   
            const reviewSummaryBars = entry.target.querySelectorAll('.profile-review-sources__summary-bar');
            const itemRatingContainers = entry.target.querySelectorAll('.profile-review-sources__list-item-rating-amount');

            itemRatingContainers.forEach(container => {
                const itemRatingAmount = container.getAttribute('data-rating');
                animateValue(container, 0, itemRatingAmount, 2000);
            });

            reviewSummaryBars.forEach(bar => {
                bar.classList.remove('w-0');
            });
            reviewSummaryBarsObserver.unobserve(entry.target);
        }
    });
}, observerConfig);

reviewSummaryBarsObserver.observe(reviewSourcesSummaryContainer);

const reviewSourcesOverallExperienceObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting)
        {   
            const overallExperienceTitle = entry.target.querySelector('.profile-review-sources__title');
            const overallExperienceRatingStars = overallExperienceTitle.querySelectorAll('.icon-star');
            const overallExperienceRatingNumber = overallExperienceTitle.getAttribute('data-stars');
            
            overallExperienceRatingStars.forEach((star, index) => {
                if (index < overallExperienceRatingNumber)
                {
                    star.addEventListener('animationend', function fillStar() {
                        star.classList.add('icon-star--yellow-fill');
                        star.removeEventListener('animationend', fillStar);
                    });
                    star.classList.add('icon-star--yellow', `icon-star--yellow-${index + 1}`);
                }
                return;
            });
            
            const overallExperienceList = entry.target.querySelector('.profile-review-sources__list');
            const overallExperienceListItems = overallExperienceList.querySelectorAll('.profile-review-sources__list-item');

            overallExperienceListItems.forEach(item => {
                const itemTitle = item.querySelector('.profile-review-sources__title--subtitle');
                const itemRating = itemTitle.getAttribute('data-stars');
                const itemStars = item.querySelectorAll('.icon-star');

                itemStars.forEach((star, index) => {
                    if (index < itemRating) {
                        star.addEventListener('animationend', function fillStar() {
                            star.classList.add('icon-star--yellow-fill');
                            star.removeEventListener('animationend', fillStar);
                        });
                        star.classList.add('icon-star--yellow', `icon-star--yellow-${index + 1}`);
                    }
                    return;
                });
            });

            reviewSourcesOverallExperienceObserver.unobserve(entry.target);
        }
    });
}, observerConfig);

reviewSourcesOverallExperienceObserver.observe(reviewSourcesOverallExperienceContainer);

// Review tooltips

const verifiedReviewCheckmarks = document.querySelectorAll('.profile-review__verified-checkmark');

verifiedReviewCheckmarks.forEach(checkmark => {
    checkmark.addEventListener('mouseenter', (e) => {
        const container = e.target.parentElement;
        const tooltip = container.querySelector('.profile-review__verified-tooltip');
        tooltip.classList.add('profile-review__verified-tooltip--visible');
    });

    checkmark.addEventListener('mouseout', (e) => {
        const container = e.target.parentElement;
        const tooltip = container.querySelector('.profile-review__verified-tooltip');
        tooltip.classList.remove('profile-review__verified-tooltip--visible');
    });
});

// Report a review to admin
async function reportReview(e) {
    e.preventDefault();

    const reportLinkElement = e.target.closest('.profile-review__report-to-admin');
    const reportToAdminText = reportLinkElement.querySelector('.profile-review__report-to-admin-text');
    if (reportLinkElement.getAttribute('data-reported') === 'true') return;

    const review = e.target.closest('.profile-review');
    const reviewId = review.dataset.reviewId;
    let formData = new FormData();
    formData.append('_csrf', document.querySelector('input[name=_csrf]').value);

    try
    {
        const res = await fetch(`/service/v1/review/${reviewId}/report`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: new URLSearchParams(formData),
        });
        
        if (res.ok)
        {
            reportLinkElement.setAttribute('data-reported', 'true');
            reportLinkElement.classList.add('profile-review__report-to-admin--success');
            reportToAdminText.innerText = 'Thankyou. This review was reported successfully.';
        }
    } 
    catch(err)
    {
        console.log(err);
    }
};

const reportToAdminLinks = document.querySelectorAll('.profile-review__report-to-admin');
reportToAdminLinks.forEach(link => link.addEventListener('click', reportReview));

function recordProfileView() {
    const branchId = _branchId;
    let formData = new FormData();
    formData.append('_csrf', document.querySelector('input[name=_csrf]').value);

    fetch('/service/v1/branch/' + branchId + '/load', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams(formData),
    });
};

recordProfileView();

// Load more reviews:

const loadMoreButtons = [...document.querySelectorAll('.profile-reviews__load-more-btn')];

if (loadMoreButtons)
{
    let pages = {
        rs:             2,
        google:         2,
        facebook:       2,
        perfectPortal:  2,
    }
    
    let currentWindowYposition;
    
    loadMoreButtons.forEach(button => {
        button.addEventListener('click', async function loadMore(e) {
            const platform = e.target.dataset.platform;
            const platformReviewsContainer = document.querySelector(`.profile-reviews__${platform}`);
            const spinner = e.target.previousElementSibling;
            const branchId = _branchId;
            currentWindowYposition = document.documentElement.scrollTop;
    
            try {
                spinner.classList.add('profile-reviews__load-more-spinner--spin');
                const res = await fetch(`/branch/${branchId}/reviews/${platform}/?page=${pages[platform]}`);
                const html = await res.text();
                pages[platform]++;
                await e.target.parentElement.insertAdjacentHTML('beforebegin', html);
                document.documentElement.scrollTop = currentWindowYposition;
    
                const newReviews = [...platformReviewsContainer.children].filter(item => item.tagName === 'ARTICLE');
                newReviews.forEach(review => {
                    const thumbBtn = review.querySelector('.profile-review__helpful-btn');
                    thumbBtn.addEventListener('click', sendFeedback, { once: true });
                    const reportToAdminLink = review.querySelector('.profile-review__report-to-admin');
                    reportToAdminLink.addEventListener('click', reportReview);
                });
    
                spinner.classList.remove('profile-reviews__load-more-spinner--spin');
                const buttons = [...platformReviewsContainer.querySelectorAll('.profile-reviews__load-more-btn')];
                buttons[0].parentNode.removeChild(buttons[0]);
            } catch(err) {
                console.log(err);
            }
        });
    });
}


// About section. Personal and Business Areas of Law Dropdowns:

const areasOfLawContainers = document.querySelectorAll('.profile-about__list--areas');

areasOfLawContainers.forEach(list => list.addEventListener('click', e => {
    const list = e.target.closest('.profile-about__list--areas');
    const listItem = e.target.closest('.profile-about__list-item');
    const allSubLists = list.querySelectorAll('.profile-about__sublist-wrapper');
    const selectedSubListWrapper = listItem.querySelector('.profile-about__sublist-wrapper');

    allSubLists.forEach(subList => {
        if (subList === selectedSubListWrapper) return;
        subList.classList.remove('profile-about__sublist-wrapper--open');
    });

    selectedSubListWrapper.classList.toggle('profile-about__sublist-wrapper--open');
}));